export const BILLING_GET_ALL = "V1_BILLING_GET_ALL";
export const BILLING_GET_ALL_BY_COID = "V1_BILLING_GET_ALL_BY_COID";
export const UPDATE_BILLING = "V1_UPDATE_BILLING";
export const BULK_PUBLISH = "V1_BULK_PUBLISH";
export const UPDATE_REMARKCOUNT_BILLING = "V1_UPDATE_REMARKCOUNT_BILLING";